<template>
  <div
    v-if="receipt.isLoading"
    class="cf-section-loader-container"
  >
    <div class="cf-loader" />
  </div>

  <div
    v-else
    class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16"
  >
    <h2 class="cf-title cf-title--2">
      Thanks for your order!
    </h2>

    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <h3 class="cf-title cf-title--3 cf-text-align-left">
        Your Order
      </h3>

      <cf-order-items
        :hide-prices="receipt.store.features.HidePrices"
        :order="receipt"
        disable-favoriting
        read-only
        is-receipt-view
      />

      <cf-order-totals
        v-if="!isItemPricingHidden"
        :order="receipt"
        :totals="{ tip: tip, totalWithTip: totalWithTip }"
      />
    </div>

    <cf-title-separator :omit-title="true" />

    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <h3 class="cf-title cf-title--3 cf-text-align-left">
        Payment Info
      </h3>

      <cf-your-payment-details
        :order="receipt"
        :payment="yourPayment"
        :display-store-location="true"
      />
    </div>

    <button
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      type="button"
      @click="closeModalHandler"
    >
      I'm finished
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';

  import CfOrderItems from '@/view/components/globals/cf-order-items/index.vue';
  import CfYourPaymentDetails from '@/view/components/globals/cf-your-payment-details/index.vue';


  export default {
    name: 'ScanToPayReceipt',

    components: {
      CfTitleSeparator,
      CfOrderItems,
      CfYourPaymentDetails
    },

    props: {
      receiptToken: {
        type: String,
        required: true
      }
    },

    computed: {
      ...mapGetters('receipt', ['receipt', 'yourPayment']),
      ...mapGetters('session', ['currentUser'])
    },

    created() {
      this.loadReceipt();
    },

    methods: {
      loadReceipt() {
        const options = { receiptToken: this.receiptToken };

        this.$store.dispatch('receipt/getReceipt', options);
      },

      isItemPricingHidden() {
        return this.receipt.store?.features?.HidePrices;
      },

      tip() {
        return this.receipt.tip;
      },

      totalWithTip() {
        const { totalWithTipAndCharges } = this.receipt;

        return totalWithTipAndCharges;
      },

      closeModalHandler() {
        this.$closeModal('scanToPayReceiptModal');

        this.$emit('confirm-handler');
      }
    }
  };
</script>
